import { allows, rightsOf, unitsOf } from '../../lib/permissions';
import { UNITS } from '../patients/patientModel';

// Messages of the team (Firestore collection "messages"): one channel per unit. New messages
// carry their channel in `unit` (and `userService`, read by the former pages); former ones only
// the sender's service, so a message of "Cuomo-Cardiologie" belongs to both channels.
export const unitsOfMessage = (message) => unitsOf(message.unit || message.userService);

export const inChannel = (message, channel) => unitsOfMessage(message).includes(String(channel || '').toLowerCase());

// Channels of an account: its units (every unit for the administration).
export const channelsOf = (user) => (user.role === 'Admin' ? UNITS : UNITS.filter((name) => unitsOf(user.service).includes(name.toLowerCase())));

export const authorOf = (message) => message.sender || message.userName || 'Inconnu';

// Readers other than the author.
export const readersOf = (message) => (Array.isArray(message.readBy) ? message.readBy.filter((name) => name && name !== message.userName) : []);

export const isUnreadFor = (message, name) => Boolean(name) && message.userName !== name && !(message.readBy || []).includes(name);

// Writing follows the level (rights grid); everyone may remove their own messages, the
// administration any of them.
export const messageAccess = (user) => {
  const rights = rightsOf(user);
  const canPost = allows(rights, 'messages', 'modifier');
  return {
    canPost,
    canDelete: (message) => user.role === 'Admin' || (canPost && message.userName === user.name),
    canDownload: allows(rights, 'messages', 'tout'),
  };
};

// Formatters built once: a conversation shows hundreds of dates.
const DAY = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
const TIME = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });

// "Aujourd'hui", "Hier", "Lundi 28 septembre 2026"
export const dayLabel = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'Date inconnue';
  const start = (day) => new Date(day.getFullYear(), day.getMonth(), day.getDate()).getTime();
  const today = start(new Date());
  const difference = Math.round((today - start(date)) / 86400000);
  if (difference === 0) return 'Aujourd’hui';
  if (difference === 1) return 'Hier';
  const label = DAY.format(date);
  return label.charAt(0).toUpperCase() + label.slice(1);
};

export const timeLabel = (value) => {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : TIME.format(date);
};
